var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:['icon', _vm.iconVariant],attrs:{"width":_vm.size,"height":_vm.size}},[_c('use',{attrs:{"href":'/static/icons/streamline/svg/'+_vm.iconVariant+'/'+_vm.icon+'.svg#icon'}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e6cf87","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/IconSvg.vue
// module id = null
// module chunks = 